import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=b428f150&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"
import style0 from "./Setting.vue?vue&type=style&index=0&id=b428f150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b428f150",
  null
  
)

export default component.exports